import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const VoltajeCombo = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		fetchUrl("/query/getVoltajes", "get", {}, {
			success: (r) => {
				let items = r.data.voltajes.map(x => ({
					value: x.idVoltaje,
					label: x.nombre
				}));

				if (props.exclusions)
					items = items.filter(x => !props.exclusions.includes(x.value.toString()));

				setItems(items);
			}
		}, { block: false });
	}, [props.exclusions]);

	return (
		<Combo
			{...props}
			items={items} />
	)
}

export default VoltajeCombo;

VoltajeCombo.defaultProps = {
	formControl: true,
	formManaged: false
};